export default function selectBody({
  dataInicio,
  dataFim,
  satelite,
  tipo,
  selectedBbox,
  selectedPolygon,
  width,
  height,
}) {
  const crs = 'http://www.opengis.net/def/crs/OGC/1.3/CRS84';
  let type = '';
  let evalscript = '';
  let bounds = {};

  if (satelite === 'sentinel_S2L1C') {
    type = 'sentinel-2-l1c';
  }

  if (satelite === 'sentinel_S2L2A') {
    type = 'sentinel-2-l2a';
  }

  if (satelite === 'landsat') {
    type = 'landsat-ot-l1';
  }

  if (tipo === 'true_color') {
    evalscript =
      '//VERSION=3\nlet minVal = 0.0;\nlet maxVal = 0.4;\n\nlet viz = new HighlightCompressVisualizer(minVal, maxVal);\n\nfunction setup() {\n   return {\n    input: ["B04", "B03", "B02","dataMask"],\n    output: { bands: 4 }\n  };\n}\n\nfunction evaluatePixel(samples) {\n    let val = [samples.B04, samples.B03, samples.B02,samples.dataMask];\n    return viz.processList(val);\n}';
    bounds = {
      properties: {
        crs,
      },
      geometry: selectedPolygon,
      // bbox: selectedBbox,
    };
  }
  if (tipo === 'ndvi') {
    bounds = {
      properties: {
        crs,
      },
      geometry: selectedPolygon,
      // bbox: selectedBbox,
    };
    evalscript =
      'let ndvi = (B08 - B04) / (B08 + B04);\n\nreturn colorBlend(ndvi,\n   [-0.2, 0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0 ],\n   [[0, 0, 0],\n    [165/255,0,38/255],\n    [215/255,48/255,39/255],\n    [244/255,109/255,67/255],\n    [253/255,174/255,97/255],\n    [254/255,224/255,139/255],\n    [255/255,255/255,191/255],\n    [217/255,239/255,139/255],\n    [166/255,217/255,106/255],\n    [102/255,189/255,99/255],\n    [26/255,152/255,80/255],\n    [0,104/255,55/255]\n   ]);';
  }
  if (tipo === 'swir') {
    bounds = {
      properties: {
        crs,
      },
      geometry: selectedPolygon,
      // bbox: selectedBbox,
    };
    evalscript =
      '//VERSION=3\nlet minVal = 0.0;\nlet maxVal = 0.4;\n\nlet viz = new HighlightCompressVisualizer(minVal, maxVal);\n\nfunction setup() {\n  return {\n    input: ["B12", "B8A", "B04","dataMask"],\n    output: { bands: 4 }\n  };\n}\n\nfunction evaluatePixel(samples) {\n    let val = [samples.B12, samples.B8A, samples.B04,samples.dataMask];\n    return viz.processList(val);\n}\n';
  }
  if (tipo === 'nwdi') {
    bounds = {
      properties: {
        crs,
      },
      geometry: selectedPolygon,
      // bbox: selectedBbox,
    };
    evalscript =
      '//VERSION=3\n//ndwi\nconst colorRamp1 = [\n  \t[0, 0xFFFFFF],\n  \t[1, 0x008000]\n  ];\nconst colorRamp2 = [\n  \t[0, 0xFFFFFF],\n  \t[1, 0x0000CC]\n  ];\n\nlet viz1 = new ColorRampVisualizer(colorRamp1);\nlet viz2 = new ColorRampVisualizer(colorRamp2);\n\nfunction setup() {\n  return {\n    input: ["B03", "B08", "SCL","dataMask"],\n    output: [\n\t\t{ id:"default", bands: 4 },\n        { id: "index", bands: 1, sampleType: "FLOAT32" },\n        { id: "eobrowserStats", bands: 2, sampleType: "FLOAT32" },\n        { id: "dataMask", bands: 1 }\n\t]\n  };\n}\n\nfunction evaluatePixel(samples) {\n  let val = index(samples.B03, samples.B08);\n  let imgVals = null;\n  // The library for tiffs works well only if there is only one channel returned.\n  // So we encode the "no data" as NaN here and ignore NaNs on frontend.\n  const indexVal = samples.dataMask === 1 ? val : NaN;\n  \n  if (val < -0) {\n    imgVals = [...viz1.process(-val), samples.dataMask];\n  } else {\n    imgVals = [...viz2.process(Math.sqrt(Math.sqrt(val))), samples.dataMask];\n  }\n  return {\n    default: imgVals,\n    index: [indexVal],\n    eobrowserStats:[val,isCloud(samples.SCL)?1:0],\n    dataMask: [samples.dataMask]\n  };\n}\n\n\nfunction isCloud(scl) {\n  if (scl == 3) {\n    // SC_CLOUD_SHADOW\n    return false;\n  } else if (scl == 9) {\n    // SC_CLOUD_HIGH_PROBA\n    return true;\n  } else if (scl == 8) {\n    // SC_CLOUD_MEDIUM_PROBA\n    return true;\n  } else if (scl == 7) {\n    // SC_CLOUD_LOW_PROBA\n    return false;\n  } else if (scl == 10) {\n    // SC_THIN_CIRRUS\n    return true;\n  } else if (scl == 11) {\n    // SC_SNOW_ICE\n    return false;\n  } else if (scl == 1) {\n    // SC_SATURATED_DEFECTIVE\n    return false;\n  } else if (scl == 2) {\n    // SC_DARK_FEATURE_SHADOW\n    return false;\n  }\n  return false;\n}\n';
  }
  if (tipo === 'ndsi') {
    bounds = {
      properties: {
        crs,
      },
      geometry: selectedPolygon,
      // bbox: selectedBbox,
    };
    evalscript =
      '//VERSION=3\nlet viz = new Identity();\n\nfunction setup() {\n  return {\n    input: ["B03", "B11","B04","B02","dataMask"],\n     output: [\n       { id: "default", bands: 4 },\n       { id: "index", bands: 1, sampleType: "FLOAT32" },\n       { id: "eobrowserStats", bands: 2, sampleType: "FLOAT32" },\n       { id: "dataMask", bands: 1 }\n     ]\n  };\n}\n\nfunction evaluatePixel(samples) {\n    let val = index(samples.B03, samples.B11);\n  \tlet imgVals = null;\n    // The library for tiffs works well only if there is only one channel returned.\n    // So we encode the "no data" as NaN here and ignore NaNs on frontend.\n    const indexVal = samples.dataMask === 1 ? val : NaN;\n  \n    if (val>0.42) \n      imgVals = [0,0.8,1,samples.dataMask];\n    else \n      imgVals = [2.5*samples.B04, 2.5*samples.B03,2.5*samples.B02,samples.dataMask];\n\t\n    const NGDR = index(samples.B03, samples.B04);\n    const bRatio = (samples.B03 - 0.175) / (0.39 - 0.175);\n      \n    const isCloud = bRatio > 1 || (bRatio > 0 && NGDR > 0);\n\n  \treturn {\n      default: imgVals,\n      index: [indexVal],\n      eobrowserStats:[val,isCloud?1:0],\n      dataMask: [samples.dataMask]\n    };\n}';
  }
  if (tipo === 'ndmi') {
    bounds = {
      properties: {
        crs,
      },
      geometry: selectedPolygon,
      // bbox: selectedBbox,
    };
    evalscript =
      '//VERSION=3\nconst moistureRamps = [\n  [-0.8, 0x800000],\n  [-0.24, 0xff0000],\n  [-0.032, 0xffff00],\n  [0.032, 0x00ffff],\n  [0.24, 0x0000ff],\n  [0.8, 0x000080],\n];\n\nconst viz = new ColorRampVisualizer(moistureRamps);\n\nfunction setup() {\n  return {\n    input: ["B03", "B04", "B8A", "B11", "dataMask"],\n    output: [\n      { id: "default", bands: 4 },\n      { id: "index", bands: 1, sampleType: "FLOAT32" },\n      { id: "eobrowserStats", bands: 2, sampleType: "FLOAT32" },\n      { id: "dataMask", bands: 1 },\n    ],\n  };\n}\n\nfunction evaluatePixel(samples) {\n  let val = index(samples.B8A, samples.B11);\n  // The library for tiffs works well only if there is only one channel returned.\n  // So we encode the "no data" as NaN here and ignore NaNs on frontend.\n  const indexVal = samples.dataMask === 1 ? val : NaN;\n  return {\n    default: [...viz.process(val), samples.dataMask],\n    index: [indexVal],\n    eobrowserStats: [val, isCloud(samples) ? 1 : 0],\n    dataMask: [samples.dataMask],\n  };\n}\n\nfunction isCloud(samples) {\n  const NGDR = index(samples.B03, samples.B04);\n  const bRatio = (samples.B03 - 0.175) / (0.39 - 0.175);\n  return bRatio > 1 || (bRatio > 0 && NGDR > 0);\n}';
  }
  if (tipo === 'moisture') {
    bounds = {
      properties: {
        crs,
      },
      geometry: selectedPolygon,
      // bbox: selectedBbox,
    };
    evalscript =
      '//VERSION=3\nconst moistureRamps = [\n    [-0.8, 0x800000],\n    [-0.24, 0xff0000],\n    [-0.032, 0xffff00],\n    [0.032, 0x00ffff],\n    [0.24, 0x0000ff],\n    [0.8, 0x000080]\n  ];\n\nconst viz = new ColorRampVisualizer(moistureRamps);\n\nfunction setup() {\n  return {\n    input: ["B8A", "B11", "SCL", "dataMask"],\n    output: [\n      { id: "default", bands: 4 },\n      { id: "index", bands: 1, sampleType: "FLOAT32" },\n      { id: "eobrowserStats", bands: 2, sampleType: "FLOAT32" },\n      { id: "dataMask", bands: 1 },\n    ],\n  };\n}\n\nfunction evaluatePixel(samples) {\n  let val = index(samples.B8A, samples.B11);\n  // The library for tiffs works well only if there is only one channel returned.\n  // So we encode the "no data" as NaN here and ignore NaNs on frontend.\n  const indexVal = samples.dataMask === 1 ? val : NaN;\n  return {\n    default: [...viz.process(val), samples.dataMask],\n    index: [indexVal],\n    eobrowserStats: [val, isCloud(samples.SCL) ? 1 : 0],\n    dataMask: [samples.dataMask],\n  };\n}\n\nfunction isCloud(scl) {\n  if (scl == 3) {\n    // SC_CLOUD_SHADOW\n    return false;\n  } else if (scl == 9) {\n    // SC_CLOUD_HIGH_PROBA\n    return true;\n  } else if (scl == 8) {\n    // SC_CLOUD_MEDIUM_PROBA\n    return true;\n  } else if (scl == 7) {\n    // SC_CLOUD_LOW_PROBA\n    return false;\n  } else if (scl == 10) {\n    // SC_THIN_CIRRUS\n    return true;\n  } else if (scl == 11) {\n    // SC_SNOW_ICE\n    return false;\n  } else if (scl == 1) {\n    // SC_SATURATED_DEFECTIVE\n    return false;\n  } else if (scl == 2) {\n    // SC_DARK_FEATURE_SHADOW\n    return false;\n  }\n  return false;\n}\n';
  }
  if (tipo === 'agriculture') {
    bounds = {
      properties: {
        crs,
      },
      geometry: selectedPolygon,
      // bbox: selectedBbox,
    };
    evalscript =
      '//VERSION=3\nlet minVal = 0.0;\nlet maxVal = 0.4;\n\nlet viz = new HighlightCompressVisualizer(minVal, maxVal);\n\nfunction setup() {\n  return {\n    input: ["B02", "B08", "B11", "dataMask"],\n    output: { bands: 4 }\n  };\n}\n\nfunction evaluatePixel(samples) {\n    let val = [samples.B11, samples.B08, samples.B02, samples.dataMask];\n    return viz.processList(val);\n}';
  }
  if (tipo === 'mapa_temperatura') {
    bounds = {
      properties: {
        crs,
      },
      geometry: selectedPolygon,
      // bbox: selectedBbox,
    };
    evalscript =
      '//VERSION=3\n\nlet minVal = 200\nlet maxVal = 375\n\nlet viz = ColorGradientVisualizer.createBlueRed(minVal, maxVal)\n\nfunction setup() {\n  return {\n    input: [{\n      bands: [\n        "B10",\n        "dataMask"\n      ]\n    }],\n    output: {\n      bands: 4\n    }\n  }\n}\n\nfunction evaluatePixel(samples) {\n  let val = samples.B10\n  val = viz.process(val)\n  val.push(samples.dataMask)\n  return val\n}';
  }

  return {
    input: {
      bounds,
      data: [
        {
          dataFilter: {
            timeRange: {
              from: `${dataInicio}T00:00:00Z`,
              to: `${dataFim}T23:59:59Z`,
            },
          },
          type,
        },
      ],
    },
    output: {
      width,
      height,
      responses: [
        {
          identifier: 'default',
          format: {
            type: 'image/png',
          },
        },
        {
          identifier: 'default',
          format: {
            type: 'image/tiff',
          },
        },
      ],
    },
    evalscript,
  };
}
